import type { PropsWithChildren } from 'react';

import { PopoverBody, VStack } from '@frontend/components';

type FiltersFieldsWrapperProps = PropsWithChildren<unknown>;

export const FiltersFieldsWrapper = ({
  children,
}: FiltersFieldsWrapperProps) => {
  return (
    <PopoverBody
      w="625px"
      maxW="100vw"
      maxH="calc(98vh - 190px)"
      py={2}
      overflowY="auto"
    >
      <VStack alignItems="start" w="100%">
        {children}
      </VStack>
    </PopoverBody>
  );
};
